import { memo } from "react";
import Audio from "../Audio";
import BrowserSupport from "../BrowserSupport";
import Connectivity from "../Connectivity";
import GeneralRecommendations from "../GeneralRecommendations";
import GetResults from "../GetResults";
import GetStarted from "../GetStarted";
import Permissions from "../Permissions";
import PermissionsError from "../PermissionsError";
import Video from "../Video";

const DiagnosticsContent = () => (
  <>
    <GetStarted />
    <GeneralRecommendations />
    <Permissions />
    <PermissionsError />
    <Video />
    <Audio />
    <BrowserSupport />
    <Connectivity />
    <GetResults />
  </>
);

export default memo(DiagnosticsContent);